import { Address, defaultAddress } from "./address";
import { PersonalInfo, defaultPersonalInfo } from "./personal_info";
import { SpouseInfo, defaultSpouseInfo } from "./spouse_info.d";

/** 
 * Type definition for a Lime user
 * TODO: update to backend's current model (e.g. no spouse)
 *
 * Note that client basically smushed resident_for_entire_year
 * and is_resident together.
 */
export interface User extends Address, PersonalInfo, SpouseInfo {
    id?: number;
    is_resident_for_the_entire_year?: boolean|null;
    is_resident?: boolean;
    is_sch_e_filed?: boolean;
    is_business_sale_filed?: boolean;
    is_retired?: boolean;
    collection_year?: string;
    email?: string;
}

export const defaultUser: User = {
    ...defaultAddress,
    ...defaultPersonalInfo,
    ...defaultSpouseInfo,
    is_jointfiling: false,
    is_resident_for_the_entire_year: null,
    is_resident: false,
    is_sch_e_filed: false,
    is_business_sale_filed: false,
    is_retired: false
}
